// Banner Carousel with Text - JavaScript
(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeBannerCarousels();
  });

  // Also initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.banner-carousel-swiper')) {
      initializeBannerCarousels();
    }
  });

  function initializeBannerCarousels() {
    const carousels = document.querySelectorAll('.banner-carousel-swiper');
    
    carousels.forEach(carousel => {
      // Skip if already initialized
      if (carousel.swiper) return;
      
      const section = carousel.closest('.banner-carousel-section');
      const sectionId = carousel.id;
      const settings = getSectionSettings(section);
      
      // Initialize Swiper
      const swiperConfig = {
        loop: true,
        speed: 1000,
        grabCursor: true,
        
        // Effect
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        
        // Autoplay
        autoplay: settings.autoplay ? {
          delay: settings.autoplaySpeed * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        
        // Navigation
        navigation: settings.showNavigation ? {
          nextEl: `#${sectionId} .swiper-button-next`,
          prevEl: `#${sectionId} .swiper-button-prev`,
        } : false,
        
        // Pagination
        pagination: settings.showPagination ? {
          el: `#${sectionId} .swiper-pagination`,
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          }
        } : false,
        
        // Responsive breakpoints
        breakpoints: {
          768: {
            speed: 1200,
          }
        },
        
        // Events
        on: {
          init: function() {
            handleVideoAutoplay(this);
            if (settings.showProgressBar) {
              initProgressBar(this, section);
            }
          },
          slideChangeTransitionStart: function() {
            pauseAllVideos(this);
          },
          slideChangeTransitionEnd: function() {
            handleVideoAutoplay(this);
            resetAnimations(this);
          }
        }
      };
      
      // Create Swiper instance
      const swiper = new Swiper(carousel, swiperConfig);
      
      // Keyboard navigation
      if (settings.keyboardNav) {
        enableKeyboardNavigation(swiper);
      }
      
      // Pause on hover for progress bar
      if (settings.showProgressBar && settings.autoplay) {
        handleProgressBarPause(carousel, swiper);
      }
    });
  }
  
  // Get section settings from data attributes or defaults
  function getSectionSettings(section) {
    // Parse settings from the section element
    const wrapper = section.querySelector('.banner-carousel-wrapper');
    const carousel = section.querySelector('.banner-carousel-swiper');
    
    // Try to get settings from data attributes (set by Liquid)
    const autoplay = carousel.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5;
    const showNavigation = carousel.dataset.showNavigation !== 'false';
    const showPagination = carousel.dataset.showPagination !== 'false';
    
    return {
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      showNavigation: showNavigation,
      showPagination: showPagination,
      showProgressBar: section.querySelector('.carousel-progress-bar') !== null,
      keyboardNav: true
    };
  }
  
  // Handle video autoplay
  function handleVideoAutoplay(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide.querySelector('video');
    
    if (video && !video.hasAttribute('data-no-autoplay')) {
      // Add a small delay to avoid race condition with pause()
      setTimeout(() => {
        // Check if video is still in the active slide before playing
        const currentActiveSlide = swiper.slides[swiper.activeIndex];
        const currentVideo = currentActiveSlide.querySelector('video');
        
        if (currentVideo === video) {
          video.currentTime = 0;
          const playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise.catch(e => {
              console.log('Video autoplay failed:', e);
              // Optionally attempt to play again after a longer delay
              setTimeout(() => {
                if (currentVideo === video && swiper.slides[swiper.activeIndex] === currentActiveSlide) {
                  video.play().catch(() => {
                    console.log('Second video autoplay attempt failed, giving up');
                  });
                }
              }, 300);
            });
          }
        }
      }, 100);
    }
  }
  
  // Pause all videos
  function pauseAllVideos(swiper) {
    swiper.slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video && !video.paused) {
        try {
          video.pause();
        } catch (e) {
          console.log('Video pause failed:', e);
        }
      }
    });
  }
  
  // Reset slide animations
  function resetAnimations(swiper) {
    // Remove animation classes from all slides
    swiper.slides.forEach(slide => {
      const animatedElements = slide.querySelectorAll('.slide-subheading, .slide-heading, .slide-text, .slide-buttons');
      animatedElements.forEach(el => {
        el.style.animation = 'none';
        el.offsetHeight; // Trigger reflow
        el.style.animation = '';
      });
    });
  }
  
  // Initialize progress bar
  function initProgressBar(swiper, section) {
    const progressBar = section.querySelector('.carousel-progress-bar');
    if (!progressBar) return;
    
    const progressFill = progressBar.querySelector('.progress-fill');
    let progressInterval;
    
    function startProgress() {
      const duration = swiper.params.autoplay.delay;
      progressFill.style.transition = `width ${duration}ms linear`;
      progressFill.style.width = '100%';
      
      progressInterval = setTimeout(() => {
        progressFill.style.transition = 'none';
        progressFill.style.width = '0';
        setTimeout(() => {
          if (swiper.params.autoplay.running) {
            startProgress();
          }
        }, 50);
      }, duration);
    }
    
    function stopProgress() {
      clearTimeout(progressInterval);
      progressFill.style.transition = 'none';
      progressFill.style.width = '0';
    }
    
    function pauseProgress() {
      const currentWidth = progressFill.offsetWidth;
      const totalWidth = progressBar.offsetWidth;
      const percentage = (currentWidth / totalWidth) * 100;
      progressFill.style.transition = 'none';
      progressFill.style.width = percentage + '%';
    }
    
    // Start progress when autoplay starts
    swiper.on('autoplayStart', startProgress);
    swiper.on('autoplayStop', stopProgress);
    swiper.on('autoplayPause', pauseProgress);
    swiper.on('autoplayResume', startProgress);
    
    // Start if autoplay is enabled
    if (swiper.params.autoplay && swiper.autoplay.running) {
      startProgress();
    }
  }
  
  // Handle progress bar pause on hover
  function handleProgressBarPause(carousel, swiper) {
    carousel.addEventListener('mouseenter', () => {
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.pause();
      }
    });
    
    carousel.addEventListener('mouseleave', () => {
      if (swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.resume();
      }
    });
  }
  
  // Enable keyboard navigation
  function enableKeyboardNavigation(swiper) {
    document.addEventListener('keydown', (e) => {
      // Only work when carousel is in viewport
      const carousel = swiper.el;
      const rect = carousel.getBoundingClientRect();
      const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
      
      if (!inViewport) return;
      
      switch(e.key) {
        case 'ArrowLeft':
          swiper.slidePrev();
          break;
        case 'ArrowRight':
          swiper.slideNext();
          break;
      }
    });
  }
  
  // Utility function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  // Handle section settings update in theme editor
  document.addEventListener('shopify:section:select', function(event) {
    const section = event.target;
    const carousel = section.querySelector('.banner-carousel-swiper');
    if (carousel && carousel.swiper) {
      carousel.swiper.autoplay.start();
    }
  });
  
  document.addEventListener('shopify:section:deselect', function(event) {
    const section = event.target;
    const carousel = section.querySelector('.banner-carousel-swiper');
    if (carousel && carousel.swiper) {
      carousel.swiper.autoplay.stop();
    }
  });
  
  // Handle block select/deselect in theme editor
  document.addEventListener('shopify:block:select', function(event) {
    const block = event.target;
    const carousel = block.closest('.banner-carousel-swiper');
    
    if (carousel && carousel.swiper) {
      const slideIndex = Array.from(carousel.querySelectorAll('.swiper-slide')).indexOf(block);
      if (slideIndex !== -1) {
        carousel.swiper.slideTo(slideIndex);
        carousel.swiper.autoplay.stop();
      }
    }
  });
  
  document.addEventListener('shopify:block:deselect', function(event) {
    const block = event.target;
    const carousel = block.closest('.banner-carousel-swiper');
    
    if (carousel && carousel.swiper) {
      carousel.swiper.autoplay.start();
    }
  });
})(); 